import { useParams } from "react-router"
import { useGetAsset } from "../components/WatchedLocations/hooks/useAssetService"
import { getLocationId } from "../utils/helpers"
import { useSearchParams } from "./useSearchParams"

/**
 * Hook for location details pages to retrieve
 * the location_id based on first the asset ID
 * and if not at asset, the id search param.
 * @returns The PHC location_id.
 */
export const useLocationId = () => {
  const { asset_id } = useParams<{ asset_id: string }>()
  const { id } = useSearchParams()

  const { data, isLoading } = useGetAsset(asset_id)
  if (isLoading) return

  const location_id = getLocationId(data?.asset) || id
  return location_id
}
